<template>
  <section class="about" id="about">
    <div class="container">
      <h2 class="section-heading wow fadeInUp">O nás</h2>
      <div class="cards-grid">
        <div class="card wow bounceInUp" data-wow-delay="0s">
          <div class="card-img">
            <img src="@/assets/images/diamond_gym_vahy.jpg" alt="Diamond Gym Nitra váhová zóna" />
          </div>
          <div class="card-body">
            <h4>Váhová zóna</h4>
            <p>
              Váhová zóna v posilovni je oblasť s rôznymi cvičebnými strojmi a
              vybavením na posilňovanie svalovej sily a vytrvalosti. Obsahuje
              voľné činky, posilňovacie lavice a multifunkčné stroje pre
              tréning s činkami.
            </p>
          </div>
        </div>
        <div class="card wow bounceInUp" data-wow-delay="0.15s">
          <div class="card-img">
            <img src="@/assets/images/diamond_gym_kardio.jpg" alt="Kardio zóna" />
          </div>
          <div class="card-body">
            <h4>Kardio zóna</h4>
            <p>
              Kardio zóna v posilovni je oblasť s rôznymi cvičebnými strojmi,
              ako sú bežecké pásy, eliptické tréningové stroje a bicykle.
              Je určená na kardiovaskulárny tréning a zlepšenie vytrvalosti.
            </p>
          </div>
        </div>
        <div class="card wow bounceInUp" data-wow-delay="0.3s">
          <div class="card-img">
            <img src="@/assets/images/diamond_fight_zona.jpg" alt="Fight zóna" />
          </div>
          <div class="card-body">
            <h4>Fight zóna</h4>
            <p>
              Fight zóna je špeciálna oblasť v posilovni vyhradená pre bojové
              športy a tréningy sebaobrany, s vhodným vybavením pre box, MMA a
              ďalšie bojové umenia.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",
}
</script>

<style scoped>
.about {
  background-color: #111;
}

.section-heading {
  font-size: clamp(26px, 4vw, 36px);
  color: #E8B923;
  text-align: center;
  margin-bottom: 48px;
  position: relative;
}

.section-heading::after {
  content: '';
  display: block;
  width: 56px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin: 12px auto 0;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.card {
  background: #1a1a1a;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 24px rgba(232, 185, 35, 0.2);
}

.card-img {
  aspect-ratio: 16 / 10;
  overflow: hidden;
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.card:hover .card-img img {
  transform: scale(1.05);
}

.card-body {
  padding: 20px;
}

.card-body h4 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #E8B923;
  letter-spacing: 0.02em;
}

.card-body p {
  font-size: 14px;
  line-height: 1.7;
  color: #bbb;
}

/* Tablet: 2 columns */
@media (min-width: 540px) and (max-width: 900px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile: 1 column */
@media (max-width: 539px) {
  .cards-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
}
</style>
